<ng-container>
    <mat-tab-group [(selectedIndex)]="tabIndex" (selectedIndexChange)="onTabChange($event)">
        <mat-tab labelClass="list-panel-tabs" *ngFor="let tab of tabs" [label]="tab.label">
            <ng-template matTabContent>
                <div class="scroll-wrapper">
                    <custom-scroll
                        [triggerScrollToPosition]="currentScrollPosition"
                        [infiniteScroll]="true"
                        (loadNextPage)="onLoadNextPage()"
                    >
                        <div class="no-hover" *ngIf="loading">
                            <loading class="loading-align-center"></loading>
                        </div>

                        <div *ngIf="!loading">
                            <ng-container *ngIf="!listItems.length">
                                <div class="no-items-message info-message-rectangle">
                                    {{ 'Survey.SurveyJobPanel.NoSurveyJobsPlaceholder' | translate }}
                                </div>
                            </ng-container>

                            <ng-container *ngIf="listItems.length">
                                <survey-job-list-item
                                    *ngFor="let job of listItems; trackBy: trackByEtag"
                                    [job]="job"
                                    [isDownloading]="downloadingIds.has(job.id)"
                                    (select)="onSelectSurveyJob($event)"
                                    (download)="downloadJob(job)"
                                    (visibilityToggle)="onJobVisibilityToggle($event)"
                                >
                                </survey-job-list-item>

                                <div class="pagination-loader no-hover" *ngIf="!allItemsLoaded">
                                    <loading></loading>
                                </div>

                                <div class="pagination-loaded" *ngIf="allItemsLoaded">
                                    <ng-container *ngIf="showEndMessage">
                                        <div class="line"></div>
                                        <div class="infinite-scroll-end-message">
                                            <i class="modus-icons">check_circle_outlined</i>
                                            {{ 'Survey.SurveyJobPanel.AllJobsLoaded' | translate }}
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                    </custom-scroll>
                </div>
            </ng-template>
        </mat-tab>
    </mat-tab-group>
</ng-container>
